import Swal from "sweetalert2";
import { defaultToast } from "./sweet_alert_helper";
import { push } from "@socialgouv/matomo-next";
import { postEventInviteUser } from "../src/queries";
import dayjs from "dayjs";

export const whereToPublish = (visible_by, groups, t) => {
  if (visible_by === "everyone") {
    return [t("common:events.form.step4.all_members"), ...groups.map((e) => e.name)].join(",");
  } else {
    return groups?.map((e) => e.name)?.join(",");
  }
};

export const canAddMembers = (event, approvedUsers) =>
  !event.approve_participants || (event.can_approve && approvedUsers.length < event.max_participants);

export const inviteUserToEvent = (event, user, t, callback) => {
  postEventInviteUser(event.slug, user.id)
    .then((response) => {
      push(["trackGoal", 5]);
      callback();
      defaultToast.fire({
        icon: "success",
        title: t("invitations.invited", { user: user.first_name }),
      });
    })
    .catch((error) => {
      console.log(error);
      callback();
      Swal.fire({
        icon: "error",
        text: t("events.form.step3.invite_count_warning"),
        customClass: {
          confirmButton: "btn btn-primary text-white me-2",
        },
        buttonsStyling: false,
      });
    });
};

export const pastEvent = (event) => dayjs(event.starts_at).isBefore(dayjs());

export const eventDateTime = (event) => {
  return `${dayjs(event.starts_at).format("DD.MM.YYYY")} ${dayjs(event.starts_at).format("HH:mm")} - ${dayjs(
    event.ends_at
  ).format("HH:mm")}`;
};
